/* eslint-disable camelcase */
import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
// import {

// } from '../actions';
import {
    SURGERY_DELETE_ATTACHMENT_REQUEST_FAILURE,
    SURGERY_USAGE_ATTACHMENT_UPLOAD_FAILURE,
} from '../actions/actionTypes';
import {
    GET_SCHEDULE_SURGERY_DETAILS_SUCCESS,
    GET_SCHEDULE_SURGERY_DETAILS_FAILURE,
    setPONonTissueImageDetails,
    setPOTissueImageDetails,
    SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS,
    GET_IMAGE_PO_PREVIEW_SUCCESS,
    GET_IMAGE_PO_PREVIEW_FAILURE,
    setShippingDetails,
    GET_SURGERY_DETAILS_FAILURE,
    GET_SURGERY_DETAILS_SUCCESS,
} from '../actions';
import {
    setSurgeryDetails,
    setCartData,
    setShippingDetailsEditMode,
    changeAcknowlegmentCheckbox,
    setProgressBarStateEditMode,
    disableSurgeryDate,
    setShippingAddress,
} from 'src/pages/scheduleSurgery/redux/actions';
import {handleSurgeryNotes} from 'src/common/redux/actions';
import { generate_UUID, setMyCaseRef } from 'src/utils/util';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { setIsMastOrder } from 'src/common/redux/actions';
import i18n from 'src/i18n';
import {VISIBLE } from 'src/constants/appConstants';

const usageAttachmentUploadEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/attachment`;
const deleteAttachmentEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/removeAttachment?fileName=${fileName}`;
const getImagePoPreviewEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/attachment?attachmentName=${fileName}`;
// const usageAttachmentUploadEndpoint = () =>
//     `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/attachment`;

// const deleteAttachmentEndpoint = (fileName) =>
//     `occ/v2/${localStorage.getItem(
//         'baseSiteId'
//     )}/order/removeAttachment?fileName=${fileName}`;

export function* getSurgeryDetails(action) {
    const progressBarState = {
        Details: {
            label: 'Details',
            progress: 0,
            current: true,
            done: false,
            displayLabel: i18n.t('scheduleSurgery.progressBar.details'),
        },
        Cart: {
            label: 'Cart',
            progress: 50,
            current: false,
            done: false,
            displayLabel: i18n.t('scheduleSurgery.progressBar.cart'),
        },
        Shipping: {
            label: 'Shipping',
            progress: 0,
            current: false,
            done: false,
            displayLabel: i18n.t('scheduleSurgery.progressBar.shipping'),
        },
        Submit: {
            label: 'Submit',
            progress: 0,
            current: false,
            done: false,
            displayLabel: i18n.t('scheduleSurgery.progressBar.submit'),
        },
    };
    const { myCaseRef, updateState, isTransferSurgery, isUnidPostpone } =
        action.payload;
    // console.log('myCaseRef1', myCaseRef);
    let url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/${myCaseRef}`;

    // let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    // const params = convertObjectToQueryParams(action.payload);
    // url += `/order/surgery?${params}`;
    // let result = yield axios.get(url).then((response) => response.data);
    // console.log('result1', result);

    if (isTransferSurgery) {
        url = `${url}?isTransfer=true`;
    }
    try {
        let result = yield axios.get(url).then((response) => response.data);
        // console.log('resultNew', result);
        let cartProducts = [];
        const {
            surgeryDetails,
            products,
            shippingDetails,
            notes: legacySurgeryNotes,
            surgeryNotes,
            customerNotes,
            pricingNotes,
            transferRecipientDetails,
        } = result.surgeryData;
        const paymentDetails = result.surgeryData.paymentDetails;
        let isCurrentDate;
        let isPreviousDate;
        const { countryISOCode } = yield select((state) => ({
            countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode
        }));
        yield put(setIsMastOrder(result?.surgeryData?.isMastOrder));
        if (surgeryDetails) {
            //delete surgeryDetails.accountName;
            delete surgeryDetails.caseCoverageFirstName;
            delete surgeryDetails.caseCoverageLastName;
            delete surgeryDetails.districtName;
            delete surgeryDetails.procedureDescription;
            delete surgeryDetails.territoryName;
            delete surgeryDetails.territoryCode;
            //delete surgeryDetails.physicianName;
            delete surgeryDetails.districtCode;
            surgeryDetails.hrefId = surgeryDetails.HRefId;
            surgeryDetails.physicianFieldText =
                surgeryDetails.physicianFieldText ||
                surgeryDetails.physicianName ||
                '';
            surgeryDetails.physicianId = surgeryDetails.physicianId==='Other Physician' ? '' : surgeryDetails.physicianId;
            surgeryDetails.physicianTextBoxType =
                surgeryDetails.physicianFieldText ||
                surgeryDetails.physicianName
                    ? 'known'
                    : 'unknown';
            surgeryDetails.surgeryRequestDeliveryDateTime =
                surgeryDetails.requestedDeliveryDate && !isTransferSurgery
                    ? new Date(surgeryDetails.requestedDeliveryDate)
                    : '';
            delete surgeryDetails.HRefId;

            const surgeryDateLocal = new Date(surgeryDetails.surgeryDateTime);

            const sugeryDateAccountTimeZone = new Date(
                surgeryDateLocal.getTime() -
                    ((-parseInt(surgeryDetails?.timeZoneOffset) || 0) * 60000 -
                        new Date().getTimezoneOffset() * 60000)
            );
            isCurrentDate =
                new Date(
                    new Date(sugeryDateAccountTimeZone).setHours(0, 0, 0, 0)
                ).getTime() === new Date().setHours(0, 0, 0, 0);
            isPreviousDate =
                new Date(
                    new Date(sugeryDateAccountTimeZone).setHours(0, 0, 0, 0)
                ).getTime() < new Date().setHours(0, 0, 0, 0);

            result.surgeryData.surgeryDetails.sugeryDateAccountTimeZone =
                sugeryDateAccountTimeZone;
        }
        if (!isTransferSurgery) {
            if (!isUnidPostpone) {
                cartProducts = (products || [])
                    .filter(
                        (product) =>
                            !(
                                product.isUnirodItem &&
                                (isCurrentDate || isPreviousDate)
                            )
                    )
                    .flatMap((product) => {
                        const baseProduct = {
                            ...product,
                            productCFN: product.cfn,
                            batchCurrentLocation:
                                product?.batchAllocation?.currentLocation,
                            batchId: product?.batchAllocation?.id,
                            batchParked: product?.batchAllocation?.isParked,
                            reservationBatchCurrentLocation:
                                product?.isReservationSet
                                    ? product?.batchAllocation?.currentLocation
                                    : null,
                            reservationBatchId: product?.isReservationSet
                                ? product?.batchAllocation?.id
                                : null,
                            shippingRequirement: product?.isReservationSet? true : product.shippingRequirement
                        };
                        
                        if (product.isSet) {
                            return Array.from({ length: +product.quantity }, () => ({
                                ...baseProduct,
                                quantity: 1,
                                productKey: generate_UUID()
                            }));
                        } else {
                            return [{
                                ...baseProduct,
                                quantity: +product.quantity,
                                productKey: generate_UUID()
                            }];
                        }
                    });
            } else {
                cartProducts = (products || []).flatMap((product) => {
                    const baseProduct = {
                        ...product,
                        productCFN: product.cfn,
                        batchCurrentLocation:
                            product?.batchAllocation?.currentLocation,
                        batchId: product?.batchAllocation?.id,
                        batchParked: product?.batchAllocation?.isParked,
                        reservationBatchCurrentLocation: product?.isReservationSet
                            ? product?.batchAllocation?.currentLocation
                            : null,
                        reservationBatchId: product?.isReservationSet
                            ? product?.batchAllocation?.id
                            : null,
                        shippingRequirement: product?.isReservationSet ? true : product.shippingRequirement
                    };
                    
                    if (product.isSet) {
                        return Array.from({ length: +product.quantity }, () => ({
                            ...baseProduct,
                            quantity: 1,
                            productKey: generate_UUID()
                        }));
                    } else {
                        return [{
                            ...baseProduct,
                            quantity: +product.quantity,
                            productKey: generate_UUID()
                        }];
                    }
                });
            }
        } else {
            cartProducts = (products || [])
                .filter(
                    (product) =>
                        (countryISOCode==='JP' ? true : product.status !== 'Not Allocated') &&
                        !product.cfn.includes('EXL') &&
                        !product.cfn.includes('EXC') &&
                        !product.cfn.includes('EXS') &&
                        !product.cfn.includes('SIM')
                )
                .flatMap((product) => {
                    const baseProduct = {
                        ...product,
                        productCFN: product.cfn,
                        batchCurrentLocation:
                            product?.batchAllocation?.currentLocation,
                        batchId: product?.batchAllocation?.id,
                        batchParked: product?.batchAllocation?.isParked,
                        reservationBatchCurrentLocation: product?.isReservationSet
                            ? product?.batchAllocation?.currentLocation
                            : null,
                        reservationBatchId: product?.isReservationSet
                            ? product?.batchAllocation?.id
                            : null,
                        shippingRequirement: product?.isReservationSet? true : product.shippingRequirement
                    };
                    
                    if (product.isSet) {
                        return Array.from({ length: +product.quantity }, () => ({
                            ...baseProduct,
                            quantity: 1,
                            productKey: generate_UUID()
                        }));
                    } else {
                        return [{
                            ...baseProduct,
                            quantity: +product.quantity,
                            productKey: generate_UUID()
                        }];
                    }
                });
        }
        yield put(disableSurgeryDate(false));
        const poSurgeryVisibility = yield select(
            (state) => state.loginReducer.poSurgeryVisibility
        );
        
        var shippingObject = {};
        var existingShippingAddress={};
        if (poSurgeryVisibility === VISIBLE) {
            shippingObject = {
                S030: {
                    shippingMethodId: '',
                    shippingAddressId: '',
                    attention: '',
                    salesOrg: '',
                    userAcknowledgement: false,
                    payment: {
                        poAttachment: '',
                        poNumber: '',
                    },
                },
                S002: {
                    shippingMethodId: '',
                    shippingAddressId: '',
                    attention: '',
                    salesOrg: '',
                    userAcknowledgement: false,
                    payment: {
                        poAttachment: '',
                        poNumber: '',
                    },
                },
            };
        } else {
            shippingObject = {
                S030: {
                    shippingMethodId: '',
                    shippingAddressId: '',
                    attention: '',
                    salesOrg: '',
                    userAcknowledgement: false,
                },
                S002: {
                    shippingMethodId: '',
                    shippingAddressId: '',
                    attention: '',
                    salesOrg: '',
                    userAcknowledgement: false,
                },
            };
        }

        if (shippingDetails) {
            shippingDetails.forEach((shipping) => {
                if (shipping?.addressId) {
                    shippingObject[
                        shipping.salesOrg !==
                        TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                            ? TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                            : TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                    ] = {
                        shippingAddressId: shipping.addressId,
                        attention: shipping.attention,
                        salesOrg: shipping.salesOrg,
                        userAcknowledgement: shipping.userAcknowledgement,
                        payment: {
                            poAttachment: paymentDetails?.[0]?.attachmentNameList?.length ? paymentDetails[0].attachmentNameList.join(',') : '',
                            poNumber: paymentDetails?.[0]?.poNumber ?? '',
                        },
                    };
                    existingShippingAddress[
                        shipping.salesOrg !==
                        TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                            ? TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                            : TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                    ] = {
                        shippingAddressId: shipping.addressId,
                        attention: shipping.attention,
                        salesOrg: shipping.salesOrg,
                        userAcknowledgement: shipping.userAcknowledgement,
                        payment: {
                            poAttachment: paymentDetails?.[0]?.attachmentNameList?.length ? paymentDetails[0].attachmentNameList.join(',') : '',
                            poNumber: paymentDetails?.[0]?.poNumber ?? '',
                        },
                    };
                }
                if (shipping?.method?.id) {
                    shippingObject[
                        shipping.salesOrg !==
                        TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                            ? TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                            : TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                    ] = {
                        shippingMethodId: shipping.method.id,
                        shippingAddressId: shipping.addressId,
                        attention: shipping.attention,
                        salesOrg: shipping.salesOrg,
                        userAcknowledgement: shipping.userAcknowledgement,
                        payment: {
                            poAttachment: paymentDetails?.[0]?.attachmentNameList?.length ? paymentDetails[0].attachmentNameList.join(',') : '',
                            poNumber: paymentDetails?.[0]?.poNumber ?? '',
                        },
                    };
                }
            });
        }

        // Populate transfer recipient details in shippingObject for modify flow
        if (transferRecipientDetails && transferRecipientDetails.length > 0) {
            const targetKey = TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue;
            shippingObject[targetKey] = {
                ...shippingObject[targetKey],
                transferRecipient: transferRecipientDetails[0].transferRecipientAddress?.addressId || '',
                careOfField: transferRecipientDetails[0].careOField || '',
            };
        }
        
        // Progress bar logic - user always lands on Details page first
        // Details is always current with progress 50
        // Other steps show completion status based on available data
        progressBarState['Details'].progress = 50; // Always current page on load
        progressBarState['Details'].current = true;
        progressBarState['Details'].done = false;
        
        if (surgeryDetails && shippingDetails && cartProducts?.length > 0) {
            // All data available
            progressBarState['Cart'].progress = 100;
            progressBarState['Cart'].done = true;
            progressBarState['Shipping'].progress = 100;
            progressBarState['Shipping'].done = true;
            progressBarState['Submit'].progress = 0;
        } else if (surgeryDetails && cartProducts?.length > 0 && !shippingDetails) {
            // Details and Cart complete, shipping pending
            progressBarState['Cart'].progress = 100;
            progressBarState['Cart'].done = true;
            progressBarState['Shipping'].progress = 0;
            progressBarState['Shipping'].done = false;
            progressBarState['Submit'].progress = 0;
        } else if (surgeryDetails && cartProducts?.length == 0) {
            // Only Details, no cart items
            progressBarState['Cart'].progress = 0;
            progressBarState['Cart'].done = false;
            progressBarState['Shipping'].progress = 0;
            progressBarState['Shipping'].done = false;
            progressBarState['Submit'].progress = 0;
        } else {
            // Just starting
            progressBarState['Cart'].progress = 0;
            progressBarState['Cart'].done = false;
            progressBarState['Shipping'].progress = 0;
            progressBarState['Shipping'].done = false;
            progressBarState['Submit'].progress = 0;
        }
        
        if (updateState) {
            yield put(setSurgeryDetails(surgeryDetails));
            yield put(
                setCartData({
                    products: cartProducts,
                })
            );
            yield put(setShippingDetailsEditMode(shippingObject));
            yield put(setShippingAddress(shippingObject));
            const loadedSurgeryNotes = surgeryNotes || legacySurgeryNotes;
            const note = [{
                customerNotes: customerNotes || [],
                surgeryNotes: loadedSurgeryNotes || [],
            }];
            yield put(handleSurgeryNotes(note));
            yield put(
                changeAcknowlegmentCheckbox({
                    name: 'pricingNotes',
                    value: pricingNotes ? pricingNotes : '',
                })
            );
            yield put(setProgressBarStateEditMode(progressBarState));
        }
        yield put({ type: GET_SURGERY_DETAILS_SUCCESS, payload: result, existingShippingAddress:existingShippingAddress });
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_SURGERY_DETAILS_FAILURE,
            payload: errorHandler('503'),
        });
    }
}

export function* getScheduleSurgeryDetailsSaga() {
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    url += '/order/generateMyCaseRef';
    try {
        const result = yield axios.get(url).then((response) => response.data);
        setMyCaseRef(result?.myCaseRef);
        yield put({
            type: GET_SCHEDULE_SURGERY_DETAILS_SUCCESS,
            myCaseRef: result.myCaseRef,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            // loadAll: value?.isLoadAll,
        });
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: '',
        });
        setMyCaseRef('');
        yield put({
            type: GET_SCHEDULE_SURGERY_DETAILS_FAILURE,
            myCaseRef: '',
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

// export function* getScheduleSurgeryDetailsSaga(action) {
//     console.log('Surgery Details Action', action);

//     let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
//     const params = convertObjectToQueryParams(action.payload);

//     console.log('Surgery Param', params);

//     url += `/order/surgery?${params}`;
//     try {
//         const result = yield axios.get(url).then((response) => response.data);
//         console.log('result1', result);
//         yield put({
//             type: GET_SCHEDULE_SURGERY_DETAILS_SUCCESS,
//             myCaseRef: result.myCASERef,
//             statusCode: result.statusCode,
//             statusMessage: result.statusMessage,
//             // loadAll: value?.isLoadAll,
//         });
//     } catch (e) {
//         console.log(e);
//         yield put({
//             type: GET_SCHEDULE_SURGERY_DETAILS_FAILURE,
//             statusCode: errorHandler('503'),
//             statusMessage: e.Error,
//         });
//     }
// }

// export const getAttachmentPromise = (attachmentObj, myCaseRef, salesOrg) => {
//     const formData = new FormData();
//     formData.append('poUploadedFile', attachmentObj, attachmentObj.name);
//     formData.append('myCaseRef', myCaseRef);
//     formData.append('salesOrg', salesOrg);
//     return usageAttachmentUploadFunc(formData);
// };

// const usageAttachmentUploadFunc = async (obj) => {
//     try {
//         const response = await axios.post(usageAttachmentUploadEndpoint(), obj);

//         return response ? response.data : {};
//     } catch (error) {
//         console.log('errorSaga', error);
//         return {};
//     }
// };
// const deleteAttachmentFunc = async (obj) => {
//     try {
//         const response = await axios.delete(
//             deleteAttachmentEndpoint(obj.fileName),
//             obj
//         );
//         return response ? response : {};
//     } catch (error) {
//         return {};
//     }
// };
// const getImagePoPreviewEndpoint = (fileName) =>
//     `occ/v2/${localStorage.getItem(
//         'baseSiteId'
//     )}/order/attachment?attachmentName=${fileName}`;

// const getImagePoPreviewFunc = async (obj) => {
//     try {
//         const response = await axios.get(
//             getImagePoPreviewEndpoint(obj.fileName)
//         );
//         return response ? response : {};
//     } catch (error) {
//         return {};
//     }
// };
export function* usageAttachmentUploadSaga(action) {
    // const { existingTissueImages, existingNonTissueImages } = yield select(
    //     (state) => ({
    //         existingTissueImages:
    //             state.equityDetailsReducer?.poTissueImageDetails,
    //         existingNonTissueImages:
    //             state.equityDetailsReducer?.poNonTissueImageDetails,
    //     })
    // );
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.surgeryReducer.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                ].payment.poAttachment,
            existingNonTissueImages:
                state.surgeryReducer.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                ].payment.poAttachment,
        })
    );
    try {
        const promiseArray = [];
        const { files, tissue, nonTissue, myCaseRef } = action.payload;
        [...(files || [])].forEach((file) => {
            if (tissue && nonTissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030'),
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            } else if (tissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030')
                );
            } else {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            }
        });

        const responses = yield Promise.all(promiseArray);
        const tissueFiles = [];
        const nonTissueFiles = [];
        responses.forEach((response) => {
            if (response?.fileName?.includes('_S030_')) {
                tissueFiles.push(response.fileName);
            } else if (response?.fileName?.includes('_S002_')) {
                nonTissueFiles.push(response.fileName);
            }
        });

        if (nonTissueFiles.length > 0) {
            yield put(
                setPONonTissueImageDetails(
                    existingNonTissueImages
                        ? `${existingNonTissueImages},${nonTissueFiles.join()}`
                        : nonTissueFiles.join()
                )
            );

            yield put(
                setShippingDetails({
                    ['payment']: existingNonTissueImages
                        ? `${existingNonTissueImages},${nonTissueFiles.join()}`
                        : nonTissueFiles.join(),
                    salesOrg: 'S002',
                    objParams: 'poAttachment',
                })
            );
            // yield put({
            //     type: EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
            //     payload: existingNonTissueImages
            //         ? `${existingNonTissueImages},${nonTissueFiles.join()}`
            //         : nonTissueFiles.join(),
            // });
        }

        if (tissueFiles.length > 0) {
            yield put(
                setPOTissueImageDetails(
                    existingTissueImages
                        ? `${existingTissueImages},${tissueFiles.join()}`
                        : tissueFiles.join()
                )
            );
            yield put(
                setShippingDetails({
                    ['payment']: existingTissueImages
                        ? `${existingTissueImages},${tissueFiles.join()}`
                        : tissueFiles.join(),
                    salesOrg: 'S030',
                    objParams: 'poAttachment',
                })
            );
            // yield put({
            //     type: EQUITY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
            //     payload: existingTissueImages
            //         ? `${existingTissueImages},${tissueFiles.join()}`
            //         : tissueFiles.join(),
            // });
        }
    } catch (e) {
        yield put({
            type: SURGERY_USAGE_ATTACHMENT_UPLOAD_FAILURE,
            payload: {},
        });
    }
}

export function* deleteAttachmentSaga(action) {
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.surgeryReducer?.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                ].payment.poAttachment.split(','),
            existingNonTissueImages:
                state.surgeryReducer?.shippingDetails[
                    TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                ].payment.poAttachment.split(','),
        })
    );
    try {
        const response = yield deleteAttachmentFunc(action.payload);
        if (response.status) {
            const { fileName, isTissue } = action.payload;

            if (isTissue) {
                const deletedImageIndex = existingTissueImages.findIndex(
                    (extImg) => extImg === fileName
                );
                existingTissueImages.splice(deletedImageIndex, 1);
            } else {
                const deletedImageIndex = existingNonTissueImages.findIndex(
                    (exntImg) => exntImg === fileName
                );
                existingNonTissueImages.splice(deletedImageIndex, 1);
            }
            yield put({
                type: SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS,
                payload: {
                    isTissue,
                    imagesToBeUpdated: isTissue
                        ? existingTissueImages.join()
                        : existingNonTissueImages.join(),
                },
            });
            yield put(
                setShippingDetails({
                    ['payment']: isTissue
                        ? existingTissueImages.join()
                        : existingNonTissueImages.join(),
                    salesOrg: isTissue
                        ? TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                        : TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
                    objParams: 'poAttachment',
                })
            );
        }
    } catch (e) {
        yield put({
            type: SURGERY_DELETE_ATTACHMENT_REQUEST_FAILURE,
            payload: {},
        });
    }
}
const getImagePoPreviewFunc = async (obj) => {
    try {
        const response = await axios.get(
            getImagePoPreviewEndpoint(obj.fileName)
        );
        return response ? response : {};
    } catch (error) {
        return {};
    }
};
const usageAttachmentUploadFunc = async (obj) => {
    try {
        const response = await axios.post(usageAttachmentUploadEndpoint(), obj);

        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

const deleteAttachmentFunc = async (obj) => {
    try {
        const response = await axios.delete(
            deleteAttachmentEndpoint(obj.fileName),
            obj
        );
        return response ? response : {};
    } catch (error) {
        return {};
    }
};

export const getAttachmentPromise = (attachmentObj, myCaseRef, salesOrg) => {
    const formData = new FormData();
    formData.append('poUploadedFile', attachmentObj, attachmentObj.name);
    formData.append('myCaseRef', myCaseRef);
    formData.append('salesOrg', salesOrg);
    return usageAttachmentUploadFunc(formData);
};

// export function* usageAttachmentUploadSaga(action) {
//     const { existingTissueImages, existingNonTissueImages } = yield select(
//         (state) => ({
//             existingTissueImages:
//                 state.surgeryDetailsReducer?.poTissueImageDetails,
//             existingNonTissueImages:
//                 state.surgeryDetailsReducer?.poNonTissueImageDetails,
//         })
//     );
//     try {
//         const promiseArray = [];
//         const { files, tissue, nonTissue, myCaseRef } = action.payload;
//         files.forEach((file) => {
//             if (tissue && nonTissue) {
//                 promiseArray.push(
//                     getAttachmentPromise(file, myCaseRef, 'S030'),
//                     getAttachmentPromise(file, myCaseRef, 'S002')
//                 );
//             } else if (tissue) {
//                 promiseArray.push(
//                     getAttachmentPromise(file, myCaseRef, 'S030')
//                 );
//             } else {
//                 promiseArray.push(
//                     getAttachmentPromise(file, myCaseRef, 'S002')
//                 );
//             }
//         });

//         const responses = yield Promise.all(promiseArray);
//         const tissueFiles = [];
//         const nonTissueFiles = [];
//         responses.forEach((response) => {
//             if (response?.fileName?.includes('_S030_')) {
//                 tissueFiles.push(response.fileName);
//             } else if (response?.fileName?.includes('_S002_')) {
//                 nonTissueFiles.push(response.fileName);
//             }
//         });

//         if (nonTissueFiles.length > 0) {
//             yield put(
//                 setPONonTissueImageDetails(
//                     existingNonTissueImages
//                         ? `${existingNonTissueImages},${nonTissueFiles.join()}`
//                         : nonTissueFiles.join()
//                 )
//             );
//             yield put(
//                 setShippingDetails({
//                     ['payment']: existingNonTissueImages
//                         ? `${existingNonTissueImages},${nonTissueFiles.join()}`
//                         : nonTissueFiles.join(),
//                     salesOrg: 'S002',
//                     objParams: 'poAttachment',
//                 })
//             );
//             // yield put({
//             //     type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
//             //     payload: existingNonTissueImages
//             //         ? `${existingNonTissueImages},${nonTissueFiles.join()}`
//             //         : nonTissueFiles.join(),
//             // });
//         }

//         if (tissueFiles.length > 0) {
//             yield put(
//                 setPOTissueImageDetails(
//                     existingTissueImages
//                         ? `${existingTissueImages},${tissueFiles.join()}`
//                         : tissueFiles.join()
//                 )
//             );
//             yield put(
//                 setShippingDetails({
//                     ['payment']: existingTissueImages
//                         ? `${existingTissueImages},${tissueFiles.join()}`
//                         : tissueFiles.join(),
//                     salesOrg: 'S030',
//                     objParams: 'poAttachment',
//                 })
//             );
//             // yield put({
//             //     type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
//             //     payload: existingTissueImages
//             //         ? `${existingTissueImages},${tissueFiles.join()}`
//             //         : tissueFiles.join(),
//             // });
//         }
//     } catch (e) {
//         yield put({
//             type: SURGERY_ATTACHMENT_UPLOAD_FAILURE,
//             payload: {},
//         });
//     }
// }

// export function* deleteAttachmentSaga(action) {
//     const { existingTissueImages, existingNonTissueImages } = yield select(
//         (state) => ({
//             existingTissueImages:
//                 state.surgeryDetailsReducer?.poTissueImageDetails?.split(
//                     ','
//                 ),
//             existingNonTissueImages:
//                 state.surgeryDetailsReducer?.poNonTissueImageDetails?.split(
//                     ','
//                 ),
//         })
//     );
//     try {
//         const response = yield deleteAttachmentFunc(action.payload);
//         if (response.status) {
//             const { fileName, isTissue } = action.payload;

//             if (isTissue) {
//                 const deletedImageIndex = existingTissueImages.findIndex(
//                     (extImg) => extImg === fileName
//                 );
//                 existingTissueImages.splice(deletedImageIndex, 1);
//             } else {
//                 const deletedImageIndex = existingNonTissueImages.findIndex(
//                     (exntImg) => exntImg === fileName
//                 );
//                 existingNonTissueImages.splice(deletedImageIndex, 1);
//             }
//             yield put({
//                 type: SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS,
//                 payload: {
//                     isTissue,
//                     imagesToBeUpdated: isTissue
//                         ? existingTissueImages.join()
//                         : existingNonTissueImages.join(),
//                 },
//             });
//             yield put(
//                 setShippingDetails({
//                     ['payment']: isTissue
//                         ? existingTissueImages.join()
//                         : existingNonTissueImages.join(),
//                     salesOrg: isTissue
//                         ? TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
//                         : TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
//                     objParams: 'poAttachment',
//                 })
//             );
//         }
//     } catch (e) {
//         yield put({
//             type: SURGERY_DELETE_ATTACHMENT_REQUEST_FAILURE,
//             payload: {},
//         });
//     }
// }
export function* getImagePoPreviewSaga(action) {
    try {
        const response = yield getImagePoPreviewFunc(action.payload);
        if (response.status) {
            yield put({
                type: GET_IMAGE_PO_PREVIEW_SUCCESS,
                payload: response.data.attachment,
            });
        }
    } catch (e) {
        yield put({
            type: GET_IMAGE_PO_PREVIEW_FAILURE,
            payload: {},
        });
    }
}
